// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_v5gIs","side-widgets":"side-widgets_rpcc1","widget":"widget_nM1E7","iconfont":"iconfont","down-app":"down-app_D3X-Q"};